import { Box, Container, Grid, Typography } from "@mui/material";
import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import MainAppBarComponent from "../../appBars/MainAppBarComponent";
import AnnouncementCarouselComponent from "../../carousel/AnnouncementCarouselComponent";
import { SampleFooterComponent } from "../../footers/SampleFooterComponent";

export const LicencesMainPageComponent = () => {
  const { t, i18n } = useTranslation();
  return (
    <div>
      <MainAppBarComponent />
      <AnnouncementCarouselComponent />
      <Container fixed>
        <Box paddingY={5}>
          <Typography variant="h5">{t("licences")}</Typography>
          <Grid container>
            <Grid item md={3} xs={4}>
              <a
                referrerPolicy="origin"
                target="_blank"
                className="a-unset"
                href="https://trustseal.enamad.ir/?id=252166&amp;Code=2HNJygVAS974XBPsZhI3"
              >
                <img
                  referrerPolicy="origin"
                  src="https://Trustseal.eNamad.ir/logo.aspx?id=252166&amp;Code=2HNJygVAS974XBPsZhI3"
                  alt=""
                  style={{ cursor: "pointer" }}
                  id="2HNJygVAS974XBPsZhI3"
                />
              </a>
            </Grid>
            <Grid item md={3} xs={4}>
              <img
                referrerPolicy="origin"
                id="rgvjesgtnbqenbqejxlzjzpe"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(
                    "https://logo.samandehi.ir/Verify.aspx?id=302217&p=xlaoobpduiwkuiwkrfthjyoe",
                    "Popup",
                    "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                  );
                }}
                alt="logo-samandehi"
                src="https://logo.samandehi.ir/logo.aspx?id=302217&p=qftilymaodrfodrfnbpdyndt"
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
      <SampleFooterComponent />
    </div>
  );
};
